export enum PlanExtensionSourceEnum {
  free = 'free',
  legacy = 'legacy',
  contracted = 'contracted'
}

export enum CompanyExtensionStatusEnum {
  active = 'active',
  canceled = 'canceled',
  scheduledCancel = 'scheduled_cancel',
  waitingPayment = 'waiting_payment',
  paymentRequired = 'payment_required',
}

export enum CompanyExtensionBillingCycleEnum {
  monthly = 'monthly',
  yearly = 'yearly'
}

export enum CatalogDisplayModeEnum {
  sorted = 'sorted',
  installedOnly = 'installedOnly',
  raw = 'raw',
}
